//export const API_URL = "http://localhost:7017/api/";
export const API_URL = "https://stephensonadventures-main.onrender.com/api/";
export const SESSION_COOKIE = "nGekeKulungeMaaStephensonSAdv";
export const TOKEN_APIKEY = "4b595606-36c7-4784-ba77-541b65a6b9f4";
export const CART_COOKIE = "cartc88585";
export const PICKUP_DETAILS = "cartDetails41145";